export default __webpack_public_path__ + "static/media/Trash.f32b0c3b.svg";